import { Grid, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import { col6 } from "../../../common/utils";
import { MeasurableValueDTO } from "../../../datasources/api-client/data-contracts";
import NumericValueWidget from "../../charts/NumericValueWidget";

export type MarketBaseType = {
	emissions?: MeasurableValueDTO;
	delta?: MeasurableValueDTO;
	coverage?: MeasurableValueDTO | null;
	isLoading: boolean;
	onReload: VoidFunction;
};

type Props = {
	marketBase?: MarketBaseType;
};

export const MarketBaseWidget = ({ marketBase }: Props) => {
	const { t } = useTranslation("common");
	return (
		<Grid container spacing={2} width={"100%"} pt={2}>
			<Grid size={12}>
				<Typography variant="h5">{t("market-based measures")}</Typography>
			</Grid>
			<Grid size={col6} minHeight={150}>
				<NumericValueWidget
					info={t("common:market based info")}
					title={t("common:total market-based emissions")}
					value={marketBase?.emissions?.value}
					measure={marketBase?.emissions?.measure}
					delta={marketBase?.delta}
					coverage={marketBase?.coverage}
					isLoading={marketBase?.isLoading}
					onReload={marketBase?.onReload}
					isMarketBase={true}
				/>
			</Grid>
		</Grid>
	);
};
